// 📁 src/pages/MarketResearch/frameworks/PESTEL.jsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../../utils/axiosInstance";
import { useIdea } from "../../../context/IdeaContext";
import ModuleHeader from "../../../components/ModuleHeader";
import { buildMDIHPdfName } from "../../../utils/pdfNaming";

const PESTEL = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { selectedIdea } = useIdea();

  /* ----------------------------------------------------- */
  const ideaId =
    state?.ideaId ||
    selectedIdea?.ideaId ||
    null;

  const ideaTitle=

    selectedIdea?.ideaTitle ||

    selectedIdea?.title ||

    state?.ideaTitle ||

    localStorage.getItem("activeIdeaTitle") ||

    "Startup Idea";

  const ideaText =
    state?.ideaText ||
    state?.idea ||
    selectedIdea?.description ||
    selectedIdea?.title ||
    "";

  const recordId =
    state?.marketResearchRecordId ||
    state?.recordId ||
    null;

  /* -----------STATE------------------------------------------ */
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const [motivationalMessage, setMotivationalMessage] = useState(null);

  useEffect(()=>{

    if(selectedIdea?.ideaTitle){

    localStorage.setItem(
    "activeIdeaTitle",
    selectedIdea.ideaTitle
    );

    }

    },[selectedIdea]);

  /* ----------------FETCH------------------------------------- */
  useEffect(() => {
    if (!ideaId || !recordId) {
      navigate("/market-research");
      return;
    }

    const fetchPESTEL = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await axios.post("/api/market-research/framework", {
          framework: "pestel",
          idea: ideaText,
          ideaId,
          recordId,
        });

        if (res.data?.result) {
          setResult(res.data.result);
          fetchMotivation();
        } else {
          setError("Failed to fetch PESTEL analysis.");
        }
      } catch (err) {
        setError("Failed to generate PESTEL analysis.");
      } finally {
        setLoading(false);
      }
    };

    const fetchMotivation = async () => {
      try {
        const response = await axios.post("/api/motivation", {
          module: "PESTEL",
          idea: ideaText,
        });

        if (response.data?.success) {
          setMotivationalMessage(response.data.message);
          setShowPopup(true);
        }
      } catch (err) {}
    };

    fetchPESTEL();
  }, [ideaId, recordId, ideaText, navigate]);

  /* ----------------------------------------------------- */
  const [loadingExport,setLoadingExport]=useState(false);

  const handleDownload = async () => {

          if(!result) return;

          try{

          setLoadingExport(true);

          const token=localStorage.getItem("token");

          const response=await axios.post(

          "/api/pdf/market-research",

          {
          ideaId,
          framework:"PESTEL"
          },

          {
          headers:{
          Authorization:`Bearer ${token}`
          },
          responseType:"blob"
          }

          );

          const blob=new Blob(
          [response.data],
          {type:"application/pdf"}
          );

          const url=
          window.URL.createObjectURL(blob);

          const link=
          document.createElement("a");

          link.href=url;

          /* ⭐ UNIVERSAL NAMING */

          const startupName = ideaTitle;

          link.download=
          buildMDIHPdfName(
          startupName,
          "MarketResearch_PESTEL"
          );

          document.body.appendChild(link);

          link.click();

          link.remove();

          }
          catch(err){

          console.error(
          "PDF download failed:",
          err
          );

          alert("Failed to download PDF");

          }
          finally{

          setLoadingExport(false);

          }

          };

  const handleMVP = () => {
    navigate("/mvp-planner", { state: { ideaId, ideaText } });
  };

  /* ----------------------------------------------------- */
  return (
    <div className="bg-slate-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-6 py-10 space-y-8 relative">

        {/* ===== HERO ===== */}
        <ModuleHeader
        title="PESTEL Analysis"
        subtitle="Evaluate external forces shaping your opportunity.Assess political, economic, social, technological,     environmental, and legal signals before scaling execution."
        currentModule="marketResearch"
        ideaTitle={ideaTitle}
        isLoadedFromDB={true}
        />

        <div className="text-sm text-gray-500 border-b border-slate-200 pb-4">

        <b>Startup:</b> {ideaTitle}

        </div>

        {error && (
          <div className="text-red-600 text-sm">
            ⚠️ {error}
          </div>
        )}

        {loading && !result && (
          <p className="text-sm text-slate-600">
            Generating PESTEL analysis...
          </p>
        )}

        {/* ===== RESULTS ===== */}
        {result && (
          <>
            <div className="space-y-6 border-b border-slate-200 pb-6">

              <h2 className="text-2xl font-semibold text-blue-900">
                Environmental Breakdown
              </h2>

              <div className="grid md:grid-cols-2 gap-6 text-sm text-slate-700 leading-relaxed">

                <div>
                  <p className="font-semibold text-blue-900 mb-1">Political</p>
                  <p>
                    {Array.isArray(result.political)
                    ? result.political.join(", ")
                    : result.political || "N/A"}
                    </p>
                </div>

                <div>
                  <p className="font-semibold text-blue-900 mb-1">Economic</p>
                  <p>
                    {Array.isArray(result.economic)
                    ? result.economic.join(", ")
                    : result.economic || "N/A"}
                    </p>
                </div>

                <div>
                  <p className="font-semibold text-blue-900 mb-1">Social</p>
                  <p>
                    {Array.isArray(result.social)
                    ? result.social.join(", ")
                    : result.social || "N/A"}
                    </p>
                </div>

                <div>
                  <p className="font-semibold text-blue-900 mb-1">Technological</p>
                  <p>
                    {Array.isArray(result.technological)
                    ? result.technological.join(", ")
                    : result.technological || "N/A"}
                    </p>
                </div>

                <div>
                  <p className="font-semibold text-blue-900 mb-1">Environmental</p>
                  <p>
                    {Array.isArray(result.environmental)
                    ? result.environmental.join(", ")
                    : result.environmental || "N/A"}
                    </p>
                </div>

                <div>
                  <p className="font-semibold text-blue-900 mb-1">Legal</p>
                  <p>
                    {Array.isArray(result.legal)
                    ? result.legal.join(", ")
                    : result.legal || "N/A"}
                    </p>
                </div>

              </div>

              <div className="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-medium">
                ✅ PESTEL Analysis Completed
              </div>
            </div>

            {/* ===== STRATEGIC TRANSITION ===== */}
            <div className="pt-6 border-t border-slate-200 space-y-3">

              <h3 className="text-lg font-semibold text-blue-900">
                Ready to Translate Macro Signals Into Strategy?
              </h3>

              <p className="text-sm text-slate-600 max-w-2xl leading-relaxed">
                Use these macro-environmental insights to refine pricing strategy,
                compliance planning, risk mitigation, and long-term positioning
                before moving into product execution.
              </p>

              {/* PRIMARY CTA */}
              <button
                onClick={handleMVP}
                className="bg-purple-600 text-white px-7 py-2.5 rounded-lg text-sm font-semibold hover:bg-purple-700 transition"
              >
                Move to MVP Planning →
              </button>

              {/* Secondary actions */}
              <div className="mt-4 flex flex-wrap gap-4 text-sm">

                <button
                  onClick={() =>
                    navigate("/market-research", {
                      state: { ideaId, ideaText, recordId },
                    })
                  }
                  className="text-slate-600 hover:text-slate-800 underline"
                >
                  🔁 Explore More Frameworks
                </button>

                <button
                  onClick={handleDownload}
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  📄 Download PDF
                </button>

                <button
                  onClick={() =>
                    navigate("/learning-mentorship", {
                      state: { topic: "PESTEL Analysis" },
                    })
                  }
                  className="text-indigo-600 hover:text-indigo-800 underline"
                >
                  🎓 Learn More About PESTEL
                </button>

              </div>
            </div>
          </>
        )}

        {/* ===== MOTIVATION POPUP ===== */}
        {showPopup && motivationalMessage && (
          <div className="fixed bottom-6 right-6 bg-yellow-100 border border-yellow-300 text-yellow-900 px-5 py-4 rounded-lg shadow-lg max-w-sm">
            <p className="font-semibold mb-1 text-sm">
              {motivationalMessage.title}
            </p>
            <p className="text-xs leading-relaxed">
              {motivationalMessage.message}
            </p>
            <button
              className="mt-2 text-xs text-blue-700 underline"
              onClick={() => setShowPopup(false)}
            >
              {motivationalMessage.ctaText || "Continue"}
            </button>
          </div>
        )}

      </div>
    </div>
  );
};

export default PESTEL;
